import Swiper, { Navigation, Pagination, Autoplay, EffectCoverflow } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectCoverflow]);

const swiperSelectors = ['.other-cases-swiper', '.cases-swiper'];
const swipersList = [];

let swiperConfig = {
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  spaceBetween: 30,
  resizeObserver: true,
};

let swiperSolutionsConfig = {
  autoHeight: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  spaceBetween: 30,
  resizeObserver: true,
};

let swiperMainConfig = {
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  spaceBetween: 30,
  resizeObserver: true,
  speed: 700,
  resistanceRatio: 0.7,
};

let swiperAppsConfig = {
  effect: 'coverflow',
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: 'auto',
  loop: true,
  initialSlide: 0,
  coverflowEffect: {
    rotate: 10,
    stretch: 0,
    depth: 150,
    modifier: 2,
    slideShadows: false,
  },
  spaceBetween: 0,
  resizeObserver: true,
  speed: 600,
  resistanceRatio: 0.6,
};

const navigationConfig = {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

const brandsConfig = {
  slidesPerView: 6,
  spaceBetween: 30,
  resizeObserver: true,
  loop: true,
  loopFillGroupWithBlank: true,
  breakpoints: {
    320: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    667: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    932: {
      slidesPerView: 6,
      spaceBetween: 30,
    },
  },
};

const reviewsConfig = {
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  spaceBetween: 30,
  resizeObserver: true,
  loop: true,
  loopFillGroupWithBlank: true,
};

swiperSelectors.forEach((selector) => {
  swipersList.push(new Swiper(selector, Object.assign({}, swiperConfig, navigationConfig)));
});

swipersList.push(new Swiper('.solutions-cases-swiper', Object.assign({}, swiperSolutionsConfig, navigationConfig)));

swipersList.push(new Swiper('.main-cases-swiper', Object.assign({}, swiperMainConfig, navigationConfig)));

swipersList.push(new Swiper('.for-banks-cases-swiper', Object.assign({}, swiperMainConfig, navigationConfig)));

swipersList.push(new Swiper('.for-horeca-cases-swiper', Object.assign({}, swiperMainConfig, navigationConfig)));

swipersList.push(new Swiper('.for-it-cases-swiper', Object.assign({}, swiperMainConfig, navigationConfig)));

/* Библиотека курсов: карточки курсов лежат в CSS-гриде, а слайдером становятся только
   на мобильных — поэтому Swiper здесь создаётся и уничтожается по matchMedia. */
const coursesLibraryConfig = {
  // ширину слайда задаёт CSS — так из-за края экрана выглядывает следующая карточка
  slidesPerView: 'auto',
  spaceBetween: 16,
  autoHeight: true,
  resizeObserver: true,
  pagination: {
    el: '.courses-library-swiper__pagination',
    type: 'bullets',
    clickable: true,
  },
};

const coursesLibraryMedia = window.matchMedia('(max-width: 768px)');
let coursesLibrarySwiper = null;

function toggleCoursesLibrarySwiper(matches) {
  const container = document.querySelector('.courses-library-swiper');

  if (!container) return;

  if (matches && !coursesLibrarySwiper) {
    coursesLibrarySwiper = new Swiper(container, coursesLibraryConfig);
  } else if (!matches && coursesLibrarySwiper) {
    coursesLibrarySwiper.destroy(true, true);
    coursesLibrarySwiper = null;
  }
}

toggleCoursesLibrarySwiper(coursesLibraryMedia.matches);

if (coursesLibraryMedia.addEventListener) {
  coursesLibraryMedia.addEventListener('change', (event) => toggleCoursesLibrarySwiper(event.matches));
} else {
  coursesLibraryMedia.addListener((event) => toggleCoursesLibrarySwiper(event.matches));
}

// подстраховка: событие matchMedia приходит не во всех окружениях,
// а toggle идемпотентен — на неизменившейся ширине он ничего не делает
window.addEventListener('resize', () => toggleCoursesLibrarySwiper(coursesLibraryMedia.matches));

const appsCarousel = new Swiper('.apps-swiper', Object.assign({}, swiperAppsConfig));
swipersList.push(appsCarousel);

const brandCarousel = new Swiper('.brand_section-container', brandsConfig);
swipersList.push(brandCarousel);

const reviewsCarousel = new Swiper('.block_reviews-container', reviewsConfig);
swipersList.push(reviewsCarousel);

const initAutoPlay = (carousel, parentClass, autoplayDelay = 3000) => {
  const otherCasesSlider = document.querySelector('.other-cases-swiper');

  if (carousel.autoplay.running || otherCasesSlider) {
    return;
  }

  let current = carousel.wrapperEl;

  if (current) {
    while (!current.classList.contains(parentClass)) {
      current = current.parentNode;
    }
    const bounding = current.getBoundingClientRect();

    const screenHeight = window.innerHeight / 2;

    if (bounding.top < screenHeight) {
      carousel.autoplay.start();
      carousel.params.autoplay.delay = autoplayDelay;
      carousel.params.autoplay.disableOnInteraction = false;
    }
  }
};

function init() {
  initAutoPlay(brandCarousel, 'brand_section', 1500);
  initAutoPlay(reviewsCarousel, 'block_reviews', 3000);
  initAutoPlay(appsCarousel, 'apps_section', 2000);
}

window.addEventListener('scroll', init);

init();

export default swipersList;
